import { User } from "../../models/API";

export interface UserAttributes {
  self_intro?: string;
  timeout?: number;
  role?: string; // admin, operator, user
  menu_order?: string[]; // Array of menu item labels in custom order
  cell_refs_enabled?: boolean; // Whether cell reference highlights are enabled (default true)
  show_data_source_selector?: boolean; // Whether data source selector is shown in ChatBox (default false)
  dark_mode?: boolean; // Whether the UI uses dark mode (default: system preference)
  // Add other attribute fields as needed
}

// Role constants
export const ROLE_ADMIN = "admin";
export const ROLE_OPERATOR = "operator";
export const ROLE_USER = "user";

// Helper function to get effective role (team_user_map overrides user table)
export const getEffectiveRole = (
  userAttributes: UserAttributes,
  teamUserMapAttributes: any
): string => {
  // If team_user_map has a role defined, it overrides the user's role
  if (teamUserMapAttributes && teamUserMapAttributes.role) {
    return teamUserMapAttributes.role;
  }
  // Otherwise, use the user's role from users table
  return userAttributes.role || ROLE_USER;
};

// Helper function to check if user can access admin console
export const canAccessAdminConsole = (effectiveRole: string): boolean => {
  return effectiveRole === ROLE_ADMIN;
};

// Helper function to check if user can create/modify/delete public resources
export const canManagePublicResources = (effectiveRole: string): boolean => {
  return effectiveRole === ROLE_ADMIN || effectiveRole === ROLE_OPERATOR;
};

export const parseUserAttributes = (user: User | null): UserAttributes => {
  if (!user || !user.attributes) {
    return {};
  }

  try {
    // Parse the JSON string to an object
    const attributes =
      typeof user.attributes === "string"
        ? JSON.parse(user.attributes)
        : user.attributes;

    return attributes;
  } catch (error) {
    console.error("Error parsing user attributes:", error);
    return {};
  }
};

export const DEFAULT_TIMEOUT = 300;
export const DEFAULT_SELF_INTRO = "";
